import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c33dc62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-selector" }
const _hoisted_2 = { class: "photo-selector__header" }
const _hoisted_3 = { class: "photo-selector__header-right" }
const _hoisted_4 = {
  key: 0,
  class: "title-search"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_message_share_settings = _resolveComponent("app-message-share-settings")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_message_share_settings, {
        class: "pointer",
        "share-settings": _ctx.shareSettings,
        onUpdateSettings: _ctx.updateShareSettings
      }, null, 8, ["share-settings", "onUpdateSettings"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["mrl-16 icon pointer", {
        'icon-tiles-2': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID_LABEL,
        'icon-tiles': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID,
        'icon-list-view': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST,
      }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.driveStore.switchPhotoView && _ctx.driveStore.switchPhotoView(...args)))
        }, null, 2),
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"])),
          class: "back-link"
        }, " Cancel "),
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
          class: _normalizeClass([{ disabled: !_ctx.selectedList.length }, "back-link"])
        }, " Done ", 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "scroll",
      onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      ref: "scroller"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["item-wrapper", {
            'item-wrapper-grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID),
            'item-wrapper-list': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST),
          }])
      }, [
        (!_ctx.dataLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.photos, (photo) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item", { 'item-grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID) }]),
                key: photo.id
              }, [
                _createVNode(_component_item_photo, {
                  photo: photo,
                  selector: "",
                  "is-parent-select": "",
                  onOnSelect: _ctx.selectPhoto,
                  "selected-id": _ctx.photoCheck[photo.id] ? photo.id : '',
                  "column-view": _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST
                }, null, 8, ["photo", "onOnSelect", "selected-id", "column-view"])
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.isPageLoading || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(21, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: _normalizeClass(["item", { 'item-grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID) }])
              }, [
                ((_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID))
                  ? (_openBlock(), _createBlock(_component_app_skeleton_rect, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_app_skeleton_media, {
                      key: 1,
                      "column-view": (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST)
                    }, null, 8, ["column-view"]))
              ], 2)
            }), 64))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.noPhotosMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.noPhotosMessage), 1))
        : _createCommentVNode("", true)
    ], 544)
  ]))
}